.content {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
